import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import styles from '../styles'
import {
  Grid,
  Dialog,
  TextField,
  DialogContent,
  DialogActions,
  withMobileDialog,
  withStyles,
  Typography,
  Hidden,
} from '@material-ui/core'
import {
  paste,
  defaultValueChange,
  toggleDefaultValuesModal,
} from 'actions/template'
import Button from 'components/theme/Button'
import { last } from 'lodash'
import MergeFieldsPreviewSelect from 'components/AddOrEditTaskPage/MergeFieldsPreviewSelect'
import { contact } from 'components/routes'
import List from 'components/ListView/List'
import { withRouter } from 'react-router-dom'

export default withRouter(
  connect(
    state => ({
      defaultValues: state.email.defaultValues,
      wysiwyg:
        state.email.sections[state.email.sectionSelected] &&
        state.email.sections[state.email.sectionSelected].editor === 'wysiwyg',
      defaultValuesModalOpen: state.email.defaultValuesModalOpen,
      emailCardSelected: last(state.email.cardSelected),
      contactListInView:
        state.view.dialogs?.contact?.open &&
        state.view.dialogs?.contact?.type === 'template',
      templateTypeSelected: state.email.templateTypeSelected,
    }),
    dispatch =>
      bindActionCreators(
        {
          paste,
          defaultValueChange,
          toggleDefaultValuesModal,
        },
        dispatch,
      ),
  )(
    withStyles(styles)(
      withMobileDialog()(
        ({
          classes,
          defaultValues,
          paste,
          defaultValueChange,
          wysiwyg,
          fullScreen,
          defaultValuesModalOpen,
          toggleDefaultValuesModal,
          emailCardSelected,
          contactListInView,
          history,
          templateTypeSelected,
        }) => {
          const mergeFieldsComponent = (
            <>
              <h3>
                Select a contact below to preview how this{' '}
                {templateTypeSelected === 'email' ? 'email' : 'text message'}{' '}
                will appear to them.
              </h3>
              <p>
                <em>
                  Selecting a contact here will populate the merge fields of
                  this contact if applicable.
                </em>
              </p>
              <div style={{ marginBottom: 40 }}>
                <MergeFieldsPreviewSelect />
              </div>
            </>
          )

          return (
            <Dialog
              fullWidth
              maxWidth="xl"
              fullScreen={fullScreen}
              open={Boolean(defaultValuesModalOpen)}
              onClose={() => toggleDefaultValuesModal(false)}
              aria-labelledby="responsive-dialog-title"
              PaperProps={{ classes: { rounded: classes.rounded } }}
            >
              <DialogContent>
                {contactListInView ? (
                  <>
                    <Typography
                      style={{
                        fontSize: 20,
                        textAlign: 'center',
                        paddingBottom: 4,
                      }}
                    >
                      Click a contact to start a conversation
                    </Typography>
                    <List history={history} {...contact} modal />
                  </>
                ) : (
                  <Grid container style={{ padding: '10px' }}>
                    <Grid item xs={12}>
                      <div>
                        {templateTypeSelected === 'email' ? (
                          <Hidden mdUp>{mergeFieldsComponent}</Hidden>
                        ) : (
                          mergeFieldsComponent
                        )}
                        <h3>Enter default values for your merge fields.</h3>
                        {defaultValues && (
                          <p>
                            <em>
                              If the contact that is receiving this{' '}
                              {emailCardSelected === 'sms'
                                ? 'message'
                                : 'email'}{' '}
                              doesn't have a value for a merge field, the values
                              entered below will appear in your{' '}
                              {emailCardSelected === 'sms'
                                ? 'message'
                                : 'email'}{' '}
                              for the corresponding merge field
                            </em>
                          </p>
                        )}
                        {Object.keys(defaultValues || {}).length ? (
                          Object.keys(defaultValues).map(key => {
                            const defaultValue = defaultValues[key]
                            return (
                              <span>
                                <div>
                                  <label>{key}</label>
                                </div>
                                <TextField
                                  variant="outlined"
                                  label={key}
                                  placeholder={`Enter a value`}
                                  value={defaultValue}
                                  onChange={e =>
                                    defaultValueChange(key, e.target.value)
                                  }
                                  className={classes.textField}
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                />
                              </span>
                            )
                          })
                        ) : (
                          <div>
                            <p>
                              <em>
                                First add some merge fields to your{' '}
                                {emailCardSelected === 'sms'
                                  ? 'message'
                                  : 'email'}
                                !
                              </em>
                            </p>
                          </div>
                        )}
                      </div>
                    </Grid>
                  </Grid>
                )}
              </DialogContent>
              <DialogActions>
                <Button onClick={() => toggleDefaultValuesModal(false)}>
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          )
        },
      ),
    ),
  ),
)
